import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useCompareStore = defineStore('compare', () => {
  const selectedIds = ref([])

  /**
   * Toggle an edition ID in the selection
   * Removes if already selected, adds if not (max4)
   * @param {string} editionId - The edition ID to toggle
   */
  function toggle(editionId) {
    if (!editionId) return
    
    const idx = selectedIds.value.indexOf(editionId)
    if (idx >= 0) {
      selectedIds.value.splice(idx, 1)
    } else if (selectedIds.value.length < 4) {
      selectedIds.value.push(editionId)
    }
  }

  /**
   * Clear all selections
   */
  function clear() {
    selectedIds.value = []
  }

  /**
   * Check if an edition is selected
   * @param {string} id - The edition ID to check
   * @returns {boolean}
   */
  function isSelected(id) {
    return selectedIds.value.includes(id)
  }

  /**
   * Whether the selection is full (4 items)
   */
  const isFull = computed(() => selectedIds.value.length >= 4)

  /**
   * Whether comparison can be performed (at least 2items)
   */
  const canCompare = computed(() => selectedIds.value.length >= 2)

  /**
   * Number of selected editions
   */
  const count = computed(() => selectedIds.value.length)

  /**
   * Whether there are any selections
   */
  const hasSelection = computed(() => selectedIds.value.length > 0)

  return {
    selectedIds,
    toggle,
    clear,
    isSelected,
    isFull,
    canCompare,
    count,
    hasSelection
  }
})